import constantFactory from "@gaoding/constant-factory";

export const {
  TRANSPARENT_IMG_BG,
  TRANSPARENT_IMG_BG_LIST,
  TRANSPARENT_IMG_BG_MAP,
  TRANSPARENT_IMG_BG_ITEM_MAP,
} = constantFactory("TRANSPARENT_IMG_BG", [
  {
    key: "GRID_BG",
    label: "GRID_BG",
    value: "grid-bg",
  },
  {
    key: "LINE_BG",
    label: "LINE_BG",
    value: "line-bg",
  },
]);
